import React, { useState, useEffect } from "react";
import CTable from "../../../../components/UI/CTable";
import { Event } from "../../../../../../cp/components/Comet";

import './style.scss';

const perPage = 20;

export default ({ title, data = [], columns = [], handleData = () => {} }) => {
    const [sourceData, setSourceData] = useState(data);
    const [tableData, setTableData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);

    useEffect(() => {
        const sliceIndex = currentPage * perPage;
        setTableData(sourceData.slice(sliceIndex, sliceIndex + perPage))
    }, [sourceData, currentPage]);

    const onChangePage = (page) => {
        setCurrentPage(page);
    };

    return <div className="activity-top-modal">
        <Event event={'activityTop'} handler={(top) => setSourceData(handleData(top?.[0]?.top || []))} />
        <h1>{title}</h1>
        <div className="activity-top-modal-content">
            <CTable
                columns={columns}
                data={tableData}
                height={'520px'}
                currentPage={currentPage}
                perPage={perPage}
                total={data.length}
                onChangePage={onChangePage}
                paginator
            />
        </div>
    </div>
}